module.exports = __webpack_public_path__ + "12d6213b1a43199f3ea63759366e7736.svg";